import { Address } from '@api/api.types'
import { BasicAddress } from '@branch-messenger/willow-ui'

export const makeAddressLineOne = (addr: Address) => `
  ${addr.address_1 || ''} ${addr.address_2 || ''}
`

export const makeAddressLineTwo = (addr: Address) => `
  ${addr.city}, ${addr.state} ${addr.zip || ''}
`

export const makeAddress = (addr: Address) => `
  ${addr.address_1 || ''} ${addr.address_2 || ''}  ${addr.city}, ${
    addr.state
  } ${addr.zip || ''}
`

export const createAddressInfo = (addr?: Address) => ({
  city: addr?.city || '',
  state: addr?.state || '',
  zip: addr?.zip || '',
  country: addr?.country || '',
  address_1: addr?.address_1 || '',
  address_2: addr?.address_2 || '',
})

export const normalizeAddress = (addr: BasicAddress, oldAddress?: Address) => {
  const address: Address = oldAddress
    ? { ...oldAddress }
    : {
        city: '',
        state: '',
        zip: '',
        country: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        care_of: '',
        address_1: '',
        address_2: '',
      }

  address.address_1 = addr.streetLine
  address.address_2 = addr.secondary!
  address.city = addr.city!
  address.state = addr.state!
  address.zip = addr.zipcode!

  return address
}
